module.exports = __webpack_public_path__ + "static/media/thumb.249f132a.jpg";